import { readingHtml } from '../../shared/reading_request';
import PronunciationService from "./pronunciation_service";
import { usesSegmentedReadingAid } from "../../reading_aids/reading_aid_languages";

class SuggestedReplyService {
  constructor(csrfToken, dialectCode) {
    this.csrfToken = csrfToken;
    this.dialectCode = dialectCode;
    this.supportedPronunciationLanguages = ['french', 'english', 'spanish'];
    this.originalSuggestions = {};
  }

  fetch(chatId, chatMessageId, text, language, context = null) {
    return fetch('/langua/suggestions', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-CSRF-Token': this.csrfToken
      },
      credentials: 'same-origin',
      body: JSON.stringify({ chat_id: chatId, chat_message_id: chatMessageId, text: text, language: language, context: context })
    })
    .then(response => response.json())
  }

  isPronunciationSupported(language) {
    return this.supportedPronunciationLanguages.includes(language.toLowerCase());
  }

  isReadingAidSupported(language) {
    return usesSegmentedReadingAid(language);
  }

  async showSuggestions(chatService, suggestions, language, readingAidService = null, isReadingAidsOn = false, owned = null) {
    if (owned && !/^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i.test(owned.messageId || '')) throw new Error('Invalid owned suggestion');
    if (owned?.isCurrent && !owned.isCurrent()) return;
    // Wait for all promises to resolve
    const content = await this.suggestionsHTML(suggestions, language, readingAidService, isReadingAidsOn, owned);

    if (owned?.isCurrent && !owned.isCurrent()) return;
    const modalHTML = `
      <div class="modal fade animate" id="chatSuggestionsModal" tabindex="-1" role="dialog" aria-labelledby="chatOptionsModalLabel" aria-hidden="true">
        <div class="modal-dialog modal-dialog-centered" role="document" style="align-items: flex-end;${window.innerWidth <= 768 ? 'margin-top: -85px;' : ''}">
          <div class="modal-content animate-bottom">
            <div class="modal-header">
              <button type="button" class="close" data-dismiss="modal" aria-label="Close" style="padding-bottom:0px;">
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div class="modal-body">
              <div class="row d-flex justify-content-center mb-4">
                ${content}
              </div>

              <div class="chat-read-aloud text-center text-muted mt-2">
                ${I18n.t('javascript.chat.read_aloud_instruction')}
              </div>
              <div class="text-center mt-3">
                <button type="button" class="btn btn-secondary" data-dismiss="modal">${I18n.t('javascript.chat.close')}</button>
              </div>
            </div>
          </div>
        </div>
      </div>
    `;

    // Append the modal HTML to the body
    document.body.insertAdjacentHTML('beforeend', modalHTML);
    const modal = document.getElementById('chatSuggestionsModal');
    await chatService.applyTransliteration(modal);

    // Event listener for suggestion option buttons
    $(document).on('click', '.js-suggestion-option-btn', function(e) {
      e.preventDefault();

      const text = $(this).data('text');

      chatService.chatInput.value = text;
      chatService.handleSubmitForm(chatService, e);

      // close modal
      $(modal).modal('hide');
    });

    let pronunciationService;
    if ((!owned || owned.pronunciationEnabled) && this.isPronunciationSupported(language)) {
      pronunciationService = new PronunciationService(chatService.csrfToken, chatService.language, this.dialectCode, owned);
      pronunciationService.updateSuggestionText = this.updateSuggestionText.bind(this);
      
      $(document).on('click', '.js-pronunciation-btn', function (e) {
        e.preventDefault();

        const pronunciationBtn = this;
        const suggestionText = $(this).data('text');
        const suggestionIndex = $(this).data('suggestion-index');
        const suggestionDiv = $(`#js-suggestion-${suggestionIndex}`);

        if (pronunciationService.alreadyRecording()) {
          pronunciationService.stopPronunciation(pronunciationBtn, suggestionText, suggestionIndex);
        } else {
          if (suggestionDiv.data('showing-pronunciation')) {
            // Show original suggestion
            suggestionDiv.html(suggestionDiv.data('original-text'));
            suggestionDiv.data('showing-pronunciation', false);
          }
          pronunciationService.startPronunciation(pronunciationBtn, suggestionText, suggestionIndex);
        }
      });
    }

    $(document).on('click', '.js-suggestion-translation-btn', function(e) {
      e.preventDefault();
      e.stopPropagation();

      // disable button to prevent multiple clicks
      e.target.disabled = true;

      const translationBtn = this;
      translationBtn.classList.add('pulse');

      if (e.handled !== true) {
        e.handled = true;
        const text = this.dataset.text

        chatService.translationService.translateSentence(text, (translatedData) => {
          if (translatedData.error) {
            translationBtn.classList.remove('pulse');
            translationBtn.remove();
            console.log(translatedData.error);
          } else {
            translationBtn.classList.remove('pulse');
            const translation = owned ? readingHtml(translatedData.translation) : translatedData.translation;
            const suggestionBtn = $(translationBtn.parentNode.parentNode.querySelector('.js-suggestion-option-btn'))
            suggestionBtn.append(`<div class="chat-suggestion-translation font-italic mt-2">${translation}</div>`);

            translationBtn.remove();
          }
        });
      }
    });

    const closeModal = () => {
      if (owned) pronunciationService?.destroy();
      // Tear down event listeners
      $(document).off('click', '.js-suggestion-option-btn');
      $(document).off('click', '.js-pronunciation-btn');
      $(document).off('click', '.js-suggestion-translation-btn');
      $(modal).modal('dispose')
      $(modal).remove();
    };

    $(modal).on('hidden.bs.modal', closeModal);

    $(modal).modal('show');
  }

  updateSuggestionText(suggestionIndex, newText, isError = false) {
    const suggestionDiv = $(`#js-suggestion-${suggestionIndex}`);
    const feedbackDiv = $(`#js-suggestion-feedback-${suggestionIndex}`);
    
    if (isError) {
      if (feedbackDiv.length === 0) {
        suggestionDiv.after(`<div id="js-suggestion-feedback-${suggestionIndex}" class="mt-2"></div>`);
      }
      $(`#js-suggestion-feedback-${suggestionIndex}`).html(newText);
    } else {
      if (!suggestionDiv.data('original-text')) {
        suggestionDiv.data('original-text', suggestionDiv.html());
      }
      suggestionDiv.html(newText);
      suggestionDiv.data('showing-pronunciation', true);
    }
  }

  async suggestionsHTML(suggestions, language, readingAidService = null, isReadingAidsOn = false, owned = null) {
    const promises = suggestions.map(async (suggestion, index) => {
      const safeSuggestion = owned ? readingHtml(suggestion) : suggestion;
      let suggestionContent = safeSuggestion;
      this.originalSuggestions[index] = suggestion;

      if (this.isReadingAidSupported(language) && readingAidService != null) {
        suggestionContent = await readingAidService.processText(suggestion, isReadingAidsOn);
        if (owned && typeof suggestionContent === 'string') suggestionContent = readingHtml(suggestionContent);

        if (typeof suggestionContent === 'object') {
          // create html element for each item in the suggestionContent
          const suggestionContentHTML = suggestionContent.map(item => {
            return `<span data-phrase="${owned ? readingHtml(item.text) : item.text}">${item.html}</span>`;
          }).join('');
          suggestionContent = suggestionContentHTML;
        } else {
          if (language !== 'chinese') {
            suggestionContent = suggestionContent.replace(/(\S+)/g, `<span class="js-audio-word word" style="cursor: pointer;" data-translated-text='${safeSuggestion.replace(/"/g, '\\"').replace(/'/g, '&#39;')}' data-language="${language}">$1</span>`);
          }
        }
      }

      const content = this.isReadingAidSupported(language) && readingAidService != null ? 
        suggestionContent : 
        safeSuggestion.replace(/(\S+)/g, `<span class="js-audio-word word" style="cursor: pointer;" data-translated-text='${safeSuggestion.replace(/"/g, '\\"').replace(/'/g, '&#39;')}' data-language="${language}">$1</span>`);

      return `
        <div class="col-12 mb-4 d-flex flex-column chat-message-content word-container" data-text="${safeSuggestion}">
          <div id="js-suggestion-${index}" class="btn btn-secondary-cta-outline white-bg py-3 w-100 mb-2 js-suggestion-option-btn flex-grow-1" style="cursor: pointer; font-size: 1rem;" data-text="${safeSuggestion}">
            ${content}
          </div>
          <div class="chat-response-option text-center pt-1">
            ${!owned || owned.speechEnabled ? `<a href="javascript:void(0)" class="btn btn-chat-secondary ${owned ? 'js-cartus-message-speech' : 'js-play-chat-audio-btn'} mr-1" ${owned ? `data-chat-message-id="${owned.messageId}" data-suggestion-index="${index}"` : ''} data-text="${safeSuggestion}" data-language="${language}">
              <i class="fa fa-volume-up" aria-hidden="true"></i>
            </a>` : ''}
            
            ${owned && !owned.pronunciationEnabled ? '' : this.isPronunciationSupported(language) ? `
            <a href="javascript:void(0)" class="btn btn-pronunciation-secondary js-pronunciation-btn ml-1" data-text="${safeSuggestion}" data-language="${language}" data-suggestion-index="${index}">
              <i class="fa fa-microphone" aria-hidden="true"></i>
              ${I18n.t('javascript.chat.say_it')}
            </a>
            ` : owned ? '' : `
            <a href="javascript:void(0)" class="btn btn-say-it btn-pronunciation js-say-it-btn ml-1" data-text="${safeSuggestion}" >
              <i class="fa fa-microphone" aria-hidden="true"></i>
              ${I18n.t('javascript.chat.say_it')}
            </a>
            `}
            
            <a href="javascript:void(0)" class="btn btn-chat-secondary js-suggestion-translation-btn ml-1" data-text="${safeSuggestion}" data-language="${language}">
              <i class="fa fa-language" aria-hidden="true"></i>
            </a>
          </div>
        </div>
      `;
    });

    return Promise.all(promises).then(results => results.join(''));
  }
}

export default SuggestedReplyService
